module.exports = __webpack_public_path__ + "img/elec_year.4f875361.png";